import React from "react";
import CustomSkeleton from "./Skeleton";

const BackSide = ({ userDetails, aiResponse, formValues}) => {
  {
    console.log(aiResponse, "userDetails");
  }
  
  if(!userDetails) return null;
  var date = new Date();
  var options = { year: 'numeric', month: 'long' };
  var year = date.getFullYear();
  var formattedDate = date.toLocaleDateString('en-US', options);
  return (
    <div className="backside-container page-section">
      <section className="backside-section">
        <div className="left-side-greeting">
          <h4 className="owner-name editable">Hello!</h4>
          <div className="message">
            <p className="editable">{aiResponse &&
              aiResponse.analysis?
              aiResponse.analysis:<CustomSkeleton count={8}/>}</p>
            <p className="editable">{aiResponse &&
            aiResponse.call_to_action ?
            aiResponse.call_to_action:<CustomSkeleton count={4}/>}</p>
          </div>
          {/* <div className="message editable">
          {aiResponse && aiResponse.new_listings && aiResponse.new_listings}
          </div> */}
          {(formValues && formValues.contact && formValues.contact === "show") ? 
          <div className="user_details_container">
           {userDetails && userDetails.avatar && <div className="avatar_wrapper">
            
                <img src={userDetails && userDetails.avatar} />
            
            </div>}
            <div className="user_details_wrapper">
              <h3 className="name editable">
                {userDetails && userDetails.fullName && userDetails.fullName}
              </h3>
              <div className="backside-contact-info">
                <div className="contact-title editable">
                  {userDetails.title && <span>{userDetails.title}</span>}
                  {userDetails.company && (
                    <span>
                      {userDetails.title ? " | " : null}
                      {userDetails.company}
                    </span>
                  )}
                
                  {userDetails.agentLicenseNumber && (
                    <span>
                      {" "}
                      {" | "}License #: {userDetails.agentLicenseNumber}
                    </span>
                  )}
                </div>
                <div className="phone editable">
                {userDetails.primaryPhone && (
                  
                    <>O: {userDetails.primaryPhone}</>
                  
                )}
                 {userDetails.mobilePhone && (
                   <>
                    <>{userDetails.primaryPhone && " | "}</>
                     <>M: {userDetails.mobilePhone}</>
                    </>
                   
                 )}
                
                </div>
                <div className="editable">
                  {userDetails && userDetails.email && userDetails.email}
                </div>
                
                <div className="editable">
                {userDetails &&
                  userDetails.streetAddress &&
                  userDetails.streetAddress}{" "}
                {userDetails && userDetails.city && userDetails.city}{" "}
                {userDetails && userDetails.state && userDetails.state}{" "}
                {userDetails && userDetails.zipCode && userDetails.zipCode}
              </div>
              </div>
            
            </div>
          </div>
          : null}
        </div>
       

        {/* Postcard Address Section */}
        <div className="address-section">
          {/* Postage box removed — postcards are mailed via service that
              applies its own indicia, so the placeholder stamp box is
              unnecessary and was eating into the safe printable area. */}
          <div className="elliman-only" style={{display:"none"}}>
            <div className="editable">575 MADISON AVENUE</div>
            <div className="editable"> NEW YORK, NEW YORK 10022 212.891.7000</div>
            <div className="editable email">elliman.com</div>
            <hr/>
            <div className="elliman-disclaimer">
            *575 MADISON AVENUE, NY, NY 10022. 212.891.7000 © {year} DOUGLAS ELLIMAN REAL ESTATE. ALL MATERIAL PRESENTED HEREIN IS INTENDED FOR INFORMATION PURPOSES ONLY. WHILE, THIS INFORMATION IS BELIEVED TO BE CORRECT, IT IS REPRESENTED SUBJECT TO ERRORS, OMISSIONS, CHANGES OR WITHDRAWAL WITHOUT NOTICE. ALL PROPERTY INFORMATION, INCLUDING, BUT NOT LIMITED TO SQUARE FOOTAGE, ROOM COUNT, NUMBER OF BEDROOMS AND THE SCHOOL DISTRICT IN PROPERTY LISTINGS SHOULD BE VERIFIED BY YOUR OWN ATTORNEY, ARCHITECT OR ZONING EXPERT. IF YOUR PROPERTY IS CURRENTLY LISTED WITH ANOTHER REAL ESTATE BROKER, PLEASE DISREGARD THIS OFFER. IT IS NOT OUR INTENTION TO SOLICIT THE OFFERINGS OF OTHER REAL ESTATE BROKERS. WE COOPERATE WITH THEM FULLY. EQUAL HOUSING OPPORTUNITY. <img src="https://marketproof-hosting.s3.us-east-1.amazonaws.com/equal-housing.png" className="equal-housing" />
            <div className="bottom">“Data Powered by MarketProof” {formattedDate}</div>
            </div>
          </div>
          <div className="address_container">
            <div className=" address editable">
            </div>
            <div className=" address editable"></div>
            <div className=" address editable"></div>
            <div className=" address editable"></div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BackSide;
